(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a6-header"]) return;
  try {
    
  if (!customElements.get('a6-navigation')) {
    customElements.define('a6-navigation', class extends HTMLElement {
      connectedCallback() {
        this.menu = this.querySelector('details');
        this.onKey = event => { if (event.key === 'Escape' && this.menu.open) { this.menu.open = false; this.menu.querySelector('summary').focus(); } };
        this.onOutside = event => { if (this.menu.open && !this.contains(event.target)) this.menu.open = false; };
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onOutside);
      }
      disconnectedCallback() { document.removeEventListener('keydown', this.onKey); document.removeEventListener('click', this.onOutside); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-article-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('a6-article')) {
    customElements.define('a6-article', class extends HTMLElement {
      connectedCallback() {
        const body = this.querySelector('[data-article-body]');
        if (!body) return;
        const reading = this.querySelector('[data-reading-time]');
        if (reading) {
          const words = body.textContent.trim().split(/\s+/).filter(Boolean).length;
          reading.textContent = this.dataset.readingLabel.replace('__count__', Math.max(1, Math.round(words / 225)));
        }
        const toc = this.querySelector('[data-article-toc]');
        const list = this.querySelector('[data-toc-list]');
        if (!toc || !list) return;
        const headings = Array.from(body.querySelectorAll('h2, h3'));
        if (headings.length < 3) return;
        list.replaceChildren();
        headings.forEach((heading, index) => {
          if (!heading.id) {
            const stem = 'a6-reading-' + index;
            let id = stem;
            let suffix = 1;
            while (document.getElementById(id)) id = stem + '-' + suffix++;
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          if (heading.tagName === 'H3') item.classList.add('a6-article__toc-child');
          item.append(link);
          list.append(item);
        });
        toc.hidden = false;
        if (!('IntersectionObserver' in window)) return;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            list.querySelectorAll('a').forEach(link => {
              const current = decodeURIComponent(link.hash.slice(1)) === entry.target.id;
              if (current) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-95px 0px -65% 0px' });
        headings.forEach(heading => this.observer.observe(heading));
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-fit-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('px-fit-quiz')) {
    class PXFitQuiz extends HTMLElement {
      static recommendation(answers, availableHandles) {
        const choices = {
          goal: ['goal_comfort', 'goal_care', 'goal_long', 'goal_active', 'goal_daily'],
          day: ['day_stand', 'day_walk', 'day_run', 'day_mix'],
          feel: ['feel_contour', 'feel_soft', 'feel_spring', 'feel_balance', 'feel_impact', 'feel_unsure'],
          shoe: ['shoe_train', 'shoe_daily', 'shoe_boot', 'shoe_other']
        };
        if (Object.keys(choices).some(key => !choices[key].includes(answers[key]))) return null;
        const handles = ['embrace', 'bouncy', 'honeycomb', 'fusion', 'plush'];
        const preference = { feel_contour: 'embrace', feel_soft: 'plush', feel_spring: 'bouncy', feel_balance: 'fusion', feel_impact: 'honeycomb' };
        const byDay = {
          day_stand: ['embrace', 'plush', 'fusion', 'bouncy', 'honeycomb'],
          day_walk: ['plush', 'fusion', 'bouncy', 'embrace', 'honeycomb'],
          day_run: ['bouncy', 'honeycomb', 'fusion', 'plush', 'embrace'],
          day_mix: ['fusion', 'bouncy', 'plush', 'embrace', 'honeycomb']
        };
        const alternatives = {
          embrace: { day_stand: 'plush', day_walk: 'plush', day_run: 'fusion', day_mix: 'fusion' },
          plush: { day_stand: 'embrace', day_walk: 'bouncy', day_run: 'bouncy', day_mix: 'fusion' },
          bouncy: { day_stand: 'plush', day_walk: 'plush', day_run: 'honeycomb', day_mix: 'fusion' },
          honeycomb: { day_stand: 'fusion', day_walk: 'bouncy', day_run: 'bouncy', day_mix: 'fusion' },
          fusion: { day_stand: 'embrace', day_walk: 'plush', day_run: 'bouncy', day_mix: 'plush' }
        };
        const preferred = preference[answers.feel] || byDay[answers.day][0];
        const ranked = [...new Set([preferred, alternatives[preferred][answers.day], ...byDay[answers.day], ...handles])];
        const available = Array.isArray(availableHandles) ? availableHandles : handles;
        const matches = ranked.filter(handle => available.includes(handle));
        return {
          handle: matches[0] || null,
          alternative: matches[1] || null,
          preferred,
          defaultFeel: answers.feel === 'feel_unsure',
          inventoryFallback: matches.length > 0 && matches[0] !== preferred
        };
      }

      static matchVariant(variants, values) {
        if (!values.length || values.some(value => !value)) return null;
        return variants.find(variant => variant.options.length === values.length && variant.options.every((value, index) => value === values[index])) || null;
      }

      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.decodeText = value => {
          const textarea = document.createElement('textarea');
          textarea.innerHTML = value;
          return textarea.value;
        };
        this.strings = Object.fromEntries(Object.entries(JSON.parse(this.querySelector('[data-quiz-strings]').textContent)).map(([key, value]) => [key, this.decodeText(value)]));
        this.intro = this.querySelector('[data-quiz-intro]');
        this.stage = this.querySelector('[data-quiz-stage]');
        this.form = this.querySelector('[data-quiz-form]');
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.results = this.querySelector('[data-quiz-results]');
        this.models = Array.from(this.querySelectorAll('[data-model]'));
        this.index = 0;
        this.answers = {};
        const start = this.querySelector('[data-quiz-start]');
        start.hidden = false;
        start.addEventListener('click', () => this.showStep(0), { signal });
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          const step = this.steps[this.index];
          const selected = step.querySelector('input:checked');
          if (!selected) {
            this.querySelector('[data-question-error]').hidden = false;
            step.querySelector('input').focus();
            return;
          }
          this.answers[step.dataset.step] = selected.value;
          if (this.index === this.steps.length - 1) this.showResult();
          else this.showStep(this.index + 1);
        }, { signal });
        this.form.addEventListener('change', () => {
          this.querySelector('[data-question-error]').hidden = true;
          const goal = this.form.querySelector('input[name="goal"]:checked')?.value;
          this.querySelector('[data-concern-note]').hidden = !['goal_comfort', 'goal_care'].includes(goal);
        }, { signal });
        this.querySelector('[data-quiz-back]').addEventListener('click', () => this.showStep(this.index - 1), { signal });
        this.querySelector('[data-quiz-edit]').addEventListener('click', () => this.showStep(0), { signal });
        this.querySelector('[data-quiz-restart]').addEventListener('click', () => {
          if (this.adding) return;
          this.answers = {};
          this.form.reset();
          this.querySelector('[data-concern-note]').hidden = true;
          this.models.forEach(model => { model.querySelector('form').reset(); this.syncVariant(model); });
          this.showStep(0);
        }, { signal });
        this.querySelector('[data-choose-alternative]').addEventListener('click', () => {
          if (this.adding || !this.alternativeHandle) return;
          this.presentProducts(this.alternativeHandle, this.selectedHandle, true);
          this.querySelector('[data-result-title]').focus({ preventScroll: true });
          this.results.scrollIntoView({ block: 'start', behavior: 'auto' });
        }, { signal });
        this.models.forEach(model => {
          model.pxVariants = JSON.parse(model.querySelector('[data-result-variants]').textContent);
          const image = model.querySelector('.px-fit-match-media img');
          model.pxDefaultImage = image ? { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') } : null;
          model.pxDefaultPrice = model.querySelector('[data-result-price]').textContent;
          model.querySelectorAll('[data-quiz-option]').forEach(select => select.addEventListener('change', () => this.syncVariant(model), { signal }));
          model.querySelector('[data-quiz-buy]').addEventListener('submit', event => { event.preventDefault(); this.addToCart(model); }, { signal });
          model.querySelector('[data-open-size-guide]').addEventListener('click', () => { this.querySelector('[data-quiz-size-guide]').open = true; }, { signal });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      showStep(index) {
        if (this.adding) return;
        this.index = Math.max(0, Math.min(index, this.steps.length - 1));
        this.dataset.active = 'true';
        this.intro.hidden = true;
        this.stage.hidden = false;
        this.results.hidden = true;
        this.steps.forEach((step, i) => { step.hidden = i !== this.index; });
        this.querySelector('[data-question-error]').hidden = true;
        this.querySelector('[data-quiz-back]').hidden = this.index === 0;
        this.querySelector('[data-quiz-next]').textContent = this.index === this.steps.length - 1 ? this.strings.result_button : this.strings.next;
        const progress = this.strings.step.replace('__current__', this.index + 1).replace('__total__', this.steps.length);
        this.querySelector('[data-quiz-progress]').textContent = progress;
        const meter = this.querySelector('[data-quiz-meter]');
        meter.value = this.index + 1;
        meter.max = this.steps.length;
        meter.setAttribute('aria-label', progress);
        this.steps[this.index].querySelector('legend').focus({ preventScroll: true });
        this.stage.scrollIntoView({ block: 'start', behavior: 'auto' });
      }

      showResult() {
        const available = this.models.filter(model => model.dataset.available === 'true' && model.pxVariants.some(variant => variant.available)).map(model => model.dataset.model);
        const recommendation = PXFitQuiz.recommendation(this.answers, available);
        if (!recommendation) { this.showStep(0); return; }
        this.recommendation = recommendation;
        this.stage.hidden = true;
        this.results.hidden = false;
        this.querySelector('[data-goal-note]').textContent = this.strings['note_' + this.answers.goal];
        this.presentProducts(recommendation.handle, recommendation.alternative, false);
        const summary = this.querySelector('[data-answer-summary]');
        summary.replaceChildren();
        this.steps.forEach(step => {
          const selected = step.querySelector('input:checked');
          const term = document.createElement('dt');
          term.textContent = step.querySelector('legend').textContent;
          const detail = document.createElement('dd');
          detail.textContent = selected ? selected.nextElementSibling.querySelector('span').textContent : '';
          summary.append(term, detail);
        });
        this.querySelector('[data-result-title]').focus({ preventScroll: true });
        this.results.scrollIntoView({ block: 'start', behavior: 'auto' });
      }

      presentProducts(handle, alternativeHandle, manual) {
        this.models.forEach(model => { model.hidden = true; });
        this.selectedHandle = handle;
        this.alternativeHandle = alternativeHandle;
        const model = this.models.find(item => item.dataset.model === handle);
        const alternative = this.models.find(item => item.dataset.model === alternativeHandle);
        const title = this.querySelector('[data-result-title]');
        title.textContent = manual ? this.strings.selected_match : this.strings.match;
        this.querySelector('[data-product-missing]').hidden = Boolean(model);
        this.querySelector('[data-goal-guidance]').hidden = !model;
        this.querySelector('[data-alternative]').hidden = !alternative;
        this.querySelector('[data-no-alternative]').hidden = !model || Boolean(alternative);
        if (!model) return;
        model.hidden = false;
        model.querySelector('.px-fit-product-label').textContent = manual ? this.strings.selected_match : this.strings.match;
        model.querySelector('[data-activity-label]').textContent = this.strings['short_' + this.answers.day.replace('day_', '')];
        const selectedFeel = this.form.querySelector('input[name="feel"]:checked')?.nextElementSibling.querySelector('span').textContent || '';
        const context = manual ? this.strings.switched : this.recommendation.inventoryFallback ? this.strings.inventory_fallback : this.recommendation.defaultFeel ? this.strings['default_' + this.answers.day.replace('day_', '')] : this.strings.preferred.replace('__feel__', selectedFeel);
        model.querySelector('[data-match-context]').textContent = context;
        model.querySelector('[data-fit-note]').textContent = this.strings['fit_' + this.answers.shoe.replace('shoe_', '')];
        model.querySelector('[data-add-status]').textContent = '';
        model.querySelector('[data-cart-link]').hidden = true;
        this.syncVariant(model);
        if (!alternative) return;
        this.querySelector('[data-alternative-title]').textContent = alternative.querySelector('[data-model-title]').textContent;
        this.querySelector('[data-alternative-feel]').textContent = alternative.querySelector('.px-fit-feel').textContent;
        this.querySelector('[data-alternative-price]').textContent = alternative.pxDefaultPrice;
        this.querySelector('[data-alternative-reason]').textContent = alternative.querySelector('[data-model-reason]').textContent;
        this.querySelector('[data-alternative-link]').href = alternative.dataset.productUrl;
        const alternativeImage = alternative.querySelector('.px-fit-match-media img');
        const imageBox = this.querySelector('[data-alternative-media]');
        imageBox.replaceChildren();
        if (alternativeImage) {
          const image = alternativeImage.cloneNode(true);
          image.removeAttribute('id');
          if (alternative.pxDefaultImage?.src) image.src = alternative.pxDefaultImage.src;
          if (alternative.pxDefaultImage?.srcset) image.srcset = alternative.pxDefaultImage.srcset;
          image.loading = 'lazy';
          imageBox.append(image);
        }
      }

      syncVariant(model) {
        const selectors = Array.from(model.querySelectorAll('[data-quiz-option]'));
        const match = PXFitQuiz.matchVariant(model.pxVariants || [], selectors.map(select => select.value));
        const size = selectors.find(select => select.dataset.isSize === 'true');
        const missingSize = size && !size.value;
        model.querySelector('[data-result-variant]').value = match?.available ? match.id : '';
        const button = model.querySelector('[data-result-add]');
        button.disabled = !match || !match.available || this.adding === true;
        button.textContent = this.strings.add;
        const status = model.querySelector('[data-variant-status]');
        status.classList.toggle('px-fit-error', !missingSize && (!match || !match.available));
        status.textContent = missingSize ? this.strings.size_prompt : !match ? this.strings.unavailable : !match.available ? this.strings.sold_out : '';
        const productLink = model.querySelector('[data-result-product]');
        const url = new URL(model.dataset.productUrl, window.location.origin);
        if (match) url.searchParams.set('variant', match.id);
        productLink.href = url.toString();
        const image = model.querySelector('.px-fit-match-media img');
        if (match) {
          model.querySelector('[data-result-price]').textContent = this.decodeText(match.price);
          if (image && match.image) { image.removeAttribute('srcset'); image.src = match.image; }
          if (match.available && size) {
            const sizeName = size.value.split(' (')[0];
            const lengths = { XS: ['25.2', '9.92'], S: ['27', '10.63'], M: ['28.5', '11.22'], L: ['30', '11.81'], XL: ['31.5', '12.40'] }[sizeName];
            if (lengths) status.textContent = this.strings.size_selected.replace('__size__', sizeName).replace('__inch__', lengths[1]).replace('__cm__', lengths[0]);
          }
        } else {
          model.querySelector('[data-result-price]').textContent = model.pxDefaultPrice;
          if (image && model.pxDefaultImage) {
            image.src = model.pxDefaultImage.src;
            if (model.pxDefaultImage.srcset) image.srcset = model.pxDefaultImage.srcset;
          }
        }
      }

      async addToCart(model) {
        if (this.adding) return;
        this.syncVariant(model);
        const button = model.querySelector('[data-result-add]');
        if (button.disabled) { model.querySelector('[data-is-size="true"]')?.focus(); return; }
        this.adding = true;
        const form = model.querySelector('[data-quiz-buy]');
        const status = model.querySelector('[data-add-status]');
        status.textContent = this.strings.adding;
        status.classList.remove('px-fit-error');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.strings.adding;
        const formData = new FormData(form);
        const pendingControls = Array.from(this.querySelectorAll('[data-quiz-option], [data-quiz-edit], [data-quiz-restart], [data-choose-alternative]'));
        pendingControls.forEach(control => { control.disabled = true; });
        const variantId = formData.get('id');
        const cart = document.querySelector('cart-drawer');
        const cartSections = cart?.getSectionsToRender ? cart.getSectionsToRender() : [];
        if (cartSections.length) {
          formData.append('sections', cartSections.map(section => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(button);
        }
        let deferred;
        const CartEvent = window.StandardEvents?.CartLinesUpdateEvent;
        try {
          if (CartEvent) {
            deferred = CartEvent.createPromise();
            deferred.promise?.catch(() => {});
            form.dispatchEvent(new CartEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
          }
          const response = await fetch(this.dataset.cartAdd, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.strings.add_error);
          status.textContent = this.strings.added;
          model.querySelector('[data-cart-link]').hidden = false;
          if (deferred) {
            fetch(this.dataset.cartUrl + '.js').then(res => res.json()).then(cartData => deferred.resolve({ cart: CartEvent.createCartFromAjaxResponse(cartData) })).catch(error => deferred.reject(error));
          }
          if (cart && cartSections.every(section => typeof data.sections?.[section.id] === 'string')) {
            try { cart.classList.remove('is-empty'); cart.renderContents(data); } catch (_) { model.querySelector('[data-cart-link]').focus(); }
          }
          this.dispatchEvent(new CustomEvent('px:cart-updated', { bubbles: true }));
        } catch (error) {
          deferred?.reject(error);
          status.textContent = error instanceof TypeError ? this.strings.add_error : error.message || this.strings.add_error;
          status.classList.add('px-fit-error');
          model.querySelector('[data-cart-link]').hidden = false;
        } finally {
          this.adding = false;
          pendingControls.forEach(control => { control.disabled = false; });
          button.removeAttribute('aria-busy');
          this.syncVariant(model);
        }
      }
    }
    customElements.define('px-fit-quiz', PXFitQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-product"]) return;
  try {
    
  (() => {
    function initializeProduct(root) {
      if (root.dataset.a6Initialized) return;
      const dataElement = root.querySelector('[data-a6-product-data]');
      if (!dataElement) return;
      const data = JSON.parse(dataElement.textContent);
      const form = root.querySelector('form');
      const productForm = root.querySelector('product-form');
      const variantSelect = root.querySelector('[data-a6-variant-select]');
      const addButton = form.querySelector('[name="add"]');
      const addLabel = addButton.querySelector('span');
      const quantity = root.querySelector('[data-a6-quantity]');
      const price = root.querySelector('[data-a6-price]');
      const stock = root.querySelector('[data-a6-stock]');
      const hint = root.querySelector('[data-a6-selection-hint]');
      const optionGroups = Array.from(root.querySelectorAll('[data-a6-option]'));
      const sizeIndex = optionGroups.findIndex(group => group.dataset.isSize === 'true');
      const selected = optionGroups.map(group => group.querySelector('[aria-pressed="true"]')?.dataset.a6OptionValue || null);
      const sticky = root.querySelector('[data-a6-sticky]');
      const stickyButton = root.querySelector('[data-a6-sticky-button]');
      const stickySelection = root.querySelector('[data-a6-sticky-selection]');
      const mainImage = root.querySelector('.a6-pdp-main-image');
      const thumbs = Array.from(root.querySelectorAll('[data-a6-thumb]'));
      const count = root.querySelector('[data-a6-gallery-count]');
      const lengths = {XS: ['25.2', '9.92'], S: ['27', '10.63'], M: ['28.5', '11.22'], L: ['30', '11.81'], XL: ['31.5', '12.40']};
      let galleryIndex = Math.max(0, thumbs.findIndex(thumb => Number(thumb.dataset.imageId) === data.initialImageId));
      let currentVariant = null;
      let mainButtonSeen = false;
      let formPending = false;
      const selectionComplete = () => data.hasOnlyDefaultVariant || selected.every(Boolean);
      const isBusy = () => addButton.classList.contains('loading');
      const isBlocked = () => addButton.getAttribute('aria-disabled') === 'true';

      function showImage(index, scrollThumb = false) {
        if (!mainImage || !thumbs.length) return;
        galleryIndex = (index + thumbs.length) % thumbs.length;
        const active = thumbs[galleryIndex];
        mainImage.removeAttribute('srcset');
        mainImage.src = active.dataset.full;
        mainImage.alt = active.dataset.alt;
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('a6-is-active', i === galleryIndex);
          if (i === galleryIndex) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        if (count) count.textContent = `${galleryIndex + 1} / ${thumbs.length}`;
        if (scrollThumb) active.parentElement.scrollTo({left: active.offsetLeft - active.parentElement.offsetLeft - 12, behavior: 'auto'});
      }
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', event => { event.preventDefault(); showImage(i); }));
      root.querySelector('[data-a6-prev]')?.addEventListener('click', () => showImage(galleryIndex - 1, true));
      root.querySelector('[data-a6-next]')?.addEventListener('click', () => showImage(galleryIndex + 1, true));
      root.querySelector('[data-a6-gallery-controls]')?.removeAttribute('hidden');
      if (count) count.textContent = `${galleryIndex + 1} / ${thumbs.length}`;

      function syncSticky() {
        const complete = selectionComplete();
        stickyButton.disabled = complete && (addButton.disabled || isBlocked() || isBusy());
        stickyButton.setAttribute('aria-busy', String(isBusy()));
        stickyButton.textContent = !complete ? (sizeIndex >= 0 ? data.labels.choose : data.labels.chooseVariant) : currentVariant?.available ? data.labels.add : currentVariant ? data.labels.soldOut : data.labels.unavailable;
        const qty = Math.max(1, parseInt(quantity.value, 10) || 1);
        const pairLabel = qty === 1 ? data.labels.onePair : data.labels.manyPairs.replace('__count__', qty);
        const sizeLabel = selected.filter(Boolean).map(value => value.split(' (')[0]).join(' / ');
        stickySelection.textContent = complete ? [sizeLabel, pairLabel, currentVariant?.price].filter(Boolean).join(' · ') : data.labels.choose;
      }
      function resetCartError() {
        if (isBusy()) return;
        productForm.error = false;
        addButton.removeAttribute('aria-disabled');
        addLabel.classList.remove('hidden');
        addButton.querySelector('.sold-out-message')?.classList.add('hidden');
        const error = root.querySelector('.product-form__error-message-wrapper');
        if (error) error.hidden = true;
      }
      function updateAvailability() {
        optionGroups.forEach((group, index) => {
          group.querySelectorAll('[data-a6-option-value]').forEach(pill => {
            const candidate = selected.slice();
            candidate[index] = pill.dataset.a6OptionValue;
            const matching = data.variants.filter(variant => candidate.every((value, i) => !value || variant.options[i] === value));
            const available = matching.some(variant => variant.available);
            pill.classList.toggle('a6-is-unavailable', !available);
            const base = pill.dataset.a6OptionValue;
            pill.setAttribute('aria-label', available ? base : `${base} · ${matching.length ? data.labels.soldOut : data.labels.unavailable}`);
          });
        });
      }
      function applySelection(updateUrl = false, clearError = false) {
        if (clearError) resetCartError();
        const complete = selectionComplete();
        currentVariant = data.hasOnlyDefaultVariant ? data.variants[0] : data.variants.find(variant => variant.options.every((value, i) => value === selected[i]));
        variantSelect.value = currentVariant && complete ? String(currentVariant.id) : '';
        addButton.disabled = !complete || !currentVariant?.available;
        addLabel.textContent = !complete ? (sizeIndex >= 0 ? data.labels.choose : data.labels.chooseVariant) : !currentVariant ? data.labels.unavailable : currentVariant.available ? data.labels.add : data.labels.soldOut;
        stock.textContent = !complete ? '' : !currentVariant ? data.labels.unavailable : currentVariant.available ? data.labels.inStock : data.labels.soldOut;
        stock.classList.toggle('a6-is-available', !!currentVariant?.available && complete);
        if (currentVariant) {
          price.textContent = currentVariant.price;
          const imageIndex = thumbs.findIndex(thumb => Number(thumb.dataset.imageId) === currentVariant.imageId);
          if (imageIndex >= 0) showImage(imageIndex);
        }
        const shortSize = sizeIndex >= 0 && selected[sizeIndex] ? selected[sizeIndex].split(' (')[0] : '';
        const sizeLength = lengths[shortSize];
        if (hint) hint.textContent = sizeLength ? data.labels.size.replace('__size__', shortSize).replace('__inch__', sizeLength[1]).replace('__cm__', sizeLength[0]) : complete ? '' : data.labels.selectionNeeded;
        if (currentVariant && complete && updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(currentVariant.id));
          window.history.replaceState({}, '', url);
        }
        updateAvailability();
        syncSticky();
      }
      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-a6-option-value]').forEach(pill => pill.addEventListener('click', () => {
          if (isBusy()) return;
          selected[index] = pill.dataset.a6OptionValue;
          group.querySelectorAll('[data-a6-option-value]').forEach(button => {
            const active = button === pill;
            button.classList.toggle('a6-is-selected', active);
            button.setAttribute('aria-pressed', String(active));
          });
          group.querySelector('[data-a6-option-label]').textContent = selected[index];
          applySelection(true, true);
        }));
      });
      root.querySelectorAll('[data-a6-quantity-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (isBusy()) return;
          const current = parseInt(quantity.value, 10) || 1;
          quantity.value = Math.max(1, current + Number(button.dataset.a6QuantityStep));
          quantity.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
      quantity.addEventListener('change', () => { resetCartError(); syncSticky(); });
      root.querySelectorAll('[data-a6-size-link]').forEach(link => link.addEventListener('click', () => {
        const disclosure = root.querySelector('.a6-pdp-size-guide');
        if (disclosure) disclosure.open = true;
      }));
      stickyButton.addEventListener('click', () => {
        if (!selectionComplete()) {
          const firstMissing = optionGroups.find((group, index) => !selected[index]);
          firstMissing?.querySelector('button')?.focus({preventScroll: true});
          firstMissing?.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        } else if (!addButton.disabled && !isBlocked()) {
          form.requestSubmit(addButton);
        }
      });
      form.addEventListener('submit', event => {
        if (!selectionComplete() || !currentVariant?.available || isBusy() || isBlocked() || !quantity.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!selectionComplete()) optionGroups.find((group, index) => !selected[index])?.querySelector('button')?.focus();
        }
      }, true);
      const observer = new MutationObserver(() => {
        const pending = isBusy();
        if (pending !== formPending) {
          formPending = pending;
          root.querySelectorAll('[data-a6-option-value], [data-a6-quantity-step]').forEach(button => { button.disabled = pending; });
          quantity.readOnly = pending;
        }
        syncSticky();
      });
      observer.observe(addButton, {attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
      root.querySelector('[data-a6-native]').hidden = true;
      variantSelect.required = false;
      root.querySelector('[data-a6-options]')?.removeAttribute('hidden');
      applySelection();
      root.dataset.a6Initialized = 'true';
      if ('IntersectionObserver' in window) {
        const positionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) mainButtonSeen = true;
            sticky.hidden = !mainButtonSeen || entry.isIntersecting || entry.boundingClientRect.top > 0;
          });
        }, {threshold: 0});
        positionObserver.observe(addButton);
      }
    }
    const initialize = container => container.querySelectorAll('[data-a6-product]').forEach(initializeProduct);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
